<template>
  <div class="home-page">
    <img src="@/assets/home/home-top-banner.png" />
    <div class="inner-page">
      <!-- 搜索 -->
      <div class="search-ipt">
        <a-select v-model:value="searchParams.type" class="search-select-box" v-if="!userInfo.isCollege&&!userInfo.isWarehouse">
          <a-select-option value="supplier">供应商</a-select-option>
          <a-select-option value="product">商品</a-select-option>
        </a-select>
        <a-select v-model:value="searchParamsCollege.type" class="search-select-box" v-else>
          <a-select-option value="product">商品</a-select-option>
        </a-select>
        <a-divider type="vertical" style="height: 30px; background-color: #E8E8E8" />
        <a-input style="width: 100%;border: none;" v-model:value="searchParams.likeName" placeholder="请输入供应商、商品…" v-if="!userInfo.isCollege&&!userInfo.isWarehouse" allowClear/>
        <a-input style="width: 100%;border: none;" v-model:value="searchParamsCollege.likeName" placeholder="请输入供应商、商品…" allowClear v-else/>
        <a-button class="search-btn" style="border: none;" type="primary" @click="toSearchPage">查询</a-button>
      </div>
      <!-- 中间商品类别，banner，消息 -->
      <div class="cate-banner-console flex " @mouseleave="cateIsHover = nul">
        <div class="cate-left"  @mouseleave="cateLeaveTimer">
          <div class="cate-inner">
            <div :class="['cate-cell pointer', 'flex', 'justify-between', {'hover': item==cateIsHover}]" @mouseenter="enterCate(item)" v-for="(item,index) in cateList" :key="index">
              <div class="flex items-center"  @click="changeCateProduct(hoverCateObj.id,item)">
                <a-image :width="28" :preview="false" style="border-radius: 28px;" :src="item.absLogoUrl"/>
                <div class="cate-name">{{ item.name }}</div>
              </div>
              <CaretRightOutlined v-if="item.children.length>0" style="color:#CCCCCC;font-size: 14px;" />
            </div>
          </div>
          <div class="cate-hover" v-if="cateIsHover && hoverCateObj.list.length>0" @mouseenter="clearTimer"  @mouseleave="cateIsHover = null">
            <div class="cate-second-name">{{hoverCateObj.name}}</div>
            <div class="cate-second-s-name" v-for="(item,index) in hoverCateObj.list" :key="index" @click="changeCateProduct(hoverCateObj.id,item)">{{item.name}}</div>
          </div>
        </div>
        <div class="cate-middle ml-20">
          <OrderBanner v-if="userInfo && isCollegeUser"></OrderBanner>
          <BannerNews v-else :bannerList="bannerList" :newsObj="newsObj"></BannerNews>
        </div>
        <div class="cate-right">
          <UnLogin v-if="!userInfo.userId"></UnLogin>
          <img v-if="userInfo.userId && !isCollegeUser" src="@/assets/home/my-console-enter.png" class="my-console-img"  @click="openManagerPage"/>
          <Notice v-if="userInfo && isCollegeUser" :noticeList="noticeList"></Notice>
          <div class="price-trend">
            <div class="trend-tips flex justify-between"><span>最新价格走势</span><div class="more text-xs pointer" @click="toPage('/main/priceTrend')">更多<RightOutlined /></div></div>
            <div class="scroll-header flex">
              <div style="width: 118px;padding-left: 47px;">名称</div>
              <div style="width: 98px;">七日最高价</div>
              <div >七日最低价</div>
            </div>
            <div class="scroll-inner-box">
              <vue3-seamless-scroll :list="priceList" class="scroll" :hover="true" :step="1" :wheel="true" :singleHeight="56">
                <div class="scroll-cell flex" v-for="(item, index) in priceList" :key="index">
                  <div class="scroll-left flex items-center">
                    <img style="border-radius: 14px;width: 38px;height: 38px;" :src="item.logoUrl"/>
                    <div class="scroll-left-name">{{item.productName}}</div>
                  </div>
                  <div class="scroll-middle flex items-center">
                    <span class="price-value">{{toFixed2(item.maxPrice)}}</span>
                    <span class="price-unit">元/{{item.unitName}}</span>
                  </div>
                  <div class="scroll-right flex items-center">
                    <span class="price-value">{{toFixed2(item.minPrice)}}</span>
                    <span class="price-unit">元/{{item.unitName}}</span>
                  </div>
                </div>
              </vue3-seamless-scroll>
            </div>
            
          </div>
        </div>
      </div>
      <!-- 普通用户登录后 经常购买 -->
      <div v-if="userInfo && !isCollegeUser && frequentList.length>0" class="frequent-purchases mt-70">
        <img src="@/assets/home/frequent-purchases.png" class="frequent-purchases-img"/>
        <div class="frequent-product-map" @mouseenter="isShowArrows=true" @mouseleave="isShowArrows=false">
          <a-carousel style="width: 100%;" :arrows="isShowArrows" :dots="false"  easing="ease-in">
            <template #prevArrow>
              <div class="custom-slick-arrow" style="left: 10px; z-index: 11">
                <LeftCircleOutlined two-tone-color="#52c41a" />
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-slick-arrow" style="right: 10px">
                <RightCircleOutlined two-tone-color="#52c41a" />
              </div>
            </template>
            <div class="frequent-scroll" v-for="(item,index) in frequentList" :key="index">
              <div class="flex">
                <OftenPurchase :product="pItem" v-for="(pItem,pidx) in item" :key="pidx"></OftenPurchase>
              </div>
              
            </div>
            
          </a-carousel>
        </div>
      </div>
      <!-- 热销商品/经常购买 -->
      <div class="hot-product mt-70">
        <!-- <div class="module-tip">{{userInfo && isCollegeUser ? '经常购买' : '热销商品'}}</div> -->
        <div class="module-tip">热销商品</div>
        
        <!-- 高校登录的经常购买 -->
        <div v-if="(userInfo&&isCollegeUser)||(userInfo.isWarehouse)">
          <a-tabs v-model:activeKey="activeRecentProductKey" @change="changeRecentTabItem" :tabBarStyle="{color:'#666666',fontSize:'16px',fontWeight:'400'}">
            <a-tab-pane v-for="(item,index) in cateRecentList" :key="item.productCategoryId" :tab="item.productCategoryName"></a-tab-pane>
          </a-tabs>
          <template v-if="_frequentCollegeList&&_frequentCollegeList.length>0">
            <div>
              <div class="flex flex-wrap">
                <RecentBuyProductCom :product="item" v-for="(item,index) in _frequentCollegeList" :key="index"></RecentBuyProductCom>
              </div>
              <LoadmoreBtn :isNoMore="hotProductCollegePageParams.total == _frequentCollegeList.length" @loadMore="parentLoadMoreCollege()" @packUp="packUpCollegeFun()"></LoadmoreBtn>
            </div>
          </template>
          <template v-if="!_frequentCollegeList || _frequentCollegeList.length==0">
            <div class="flex items-center justify-center container p-20 ">
              <img class="w-308 h-292" src="@/assets/no-data.png" />
            </div>
          </template>
        </div>
        <!-- 热销商品 -->
        <div v-else>
          <a-tabs v-model:activeKey="activeHotProductKey" @change="changeTabItem" :tabBarStyle="{color:'#666666',fontSize:'16px',fontWeight:'400'}">
            <a-tab-pane :class="{'active-tab':!activeHotProductKey}" key="" tab="全部"></a-tab-pane>
            <a-tab-pane :class="{'active-tab':item.id == activeHotProductKey}" v-for="(item,index) in cateList" :key="item.id" :tab="item.name"></a-tab-pane>
          </a-tabs>
          <div class="flex flex-wrap">
            <HotProductCom :product="item" v-for="(item,index) in hotProductList" :key="index"></HotProductCom>
          </div>
          <LoadmoreBtn :isNoMore="hotProductPageParams.total == hotProductList.length" @loadMore="parentLoadMore('hot')" @packUp="packUpFun('hot')"></LoadmoreBtn>
        </div>
      </div>
      <!-- 优质供应商 -->
      <div class="supplier">
        <div class="module-tip">优质供应商</div>
        <a-spin :spinning="proSpinning" size="large">
          <div class="flex flex-wrap">
          <SupplierCom :supplier="item" v-for="(item,index) in supplierList" :key="index"></SupplierCom>
        </div>
        </a-spin>
        <LoadmoreBtn :isNoMore="searchSupplierParams.total == supplierList.length" @loadMore="parentSupplierLoadMore" @packUp="packUpSupplierFun"></LoadmoreBtn>
      </div>
    </div>
  </div>
</template>

<script setup>
  import OftenPurchase from '@/components/home/oftenPurchase.vue'
  import BannerNews from "@/components/home/bannerNews.vue";
  import OrderBanner from "@/components/home/orderBanner.vue";
  import UnLogin from "@/components/home/unLogin.vue";
  import Notice from "@/components/home/notice.vue";
  import LoadmoreBtn from "@/components/com/loadmoreBtn/index.vue";
  import RecentBuyProductCom from "@/components/home/recentBuyProductCom.vue";
  import HotProductCom from "@/components/home/hotProductCom.vue";
  import SupplierCom from "@/components/home/supplierCom.vue";
  import utils from '@/utils';
  import { CaretRightOutlined, LeftCircleOutlined,RightCircleOutlined, RightOutlined } from '@ant-design/icons-vue';

  import { useRouter } from "vue-router";
  import { useStore } from "vuex";
  import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
  import { ref, onMounted, computed, watch  } from "vue"
  import api from '@/net/api'
  const router = useRouter();
  const store = useStore();
  const userInfo = computed(()=>store.state.user.userInfo) //ref(true)//;
  const currentCity = computed(() => store.state.city.currentCity)

  // 轮播图
  const bannerList = ref([])
  // 舆情信息
  const newsObj = ref([])
  // console.log(userInfo);
  const isCollegeUser = computed(() => store.state.user.userInfo.isCollege)
  // console.log('isCollegeUser',isCollegeUser.value)
  // 优质供应商list
  const supplierList = ref([])
  // 优质供应商——搜索条件
  const searchSupplierParams = ref({
    currentPage:1,
    pageSize:12
  })
  //加载中
  const proSpinning = ref(false)
  // 获取供应商列表
  function getSupplierList(){
    proSpinning.value = true
    let p = {
      districtCode:currentCity.value.code,
      ...searchSupplierParams.value
    }
    let _userInfo = store.state.user.userInfo
    if(_userInfo.isCollege||_userInfo.isWarehouse){
      p.buyerOrgId = _userInfo.businessOrgId
      delete p.districtCode
    }
    api.post_plat_index_supplier(p).then(res=>{
      if(res){
        proSpinning.value = false
        if(p.currentPage==1){
          supplierList.value = res.list
        }else{
          supplierList.value = supplierList.value.concat(res.list)
        }
        searchSupplierParams.value.total = res.total
        // console.log(supplierList)
      }
    })
    
    
  }
  // 优质供应商列表收起
  function packUpSupplierFun(){
    searchSupplierParams.value.currentPage = 1
    getSupplierList()
  }
  //优质供应商列表加载下一页
  function parentSupplierLoadMore(){
    searchSupplierParams.value.currentPage++
    getSupplierList()
  }
  // 高校账户经常购买的商品================================
  
  
  const frequentCollegeList = ref([])
  const _frequentCollegeList = ref([])
  const activeRecentProductKey=ref('')
  // 高校账户经常购买的商品——搜索条件
  // 切换高校账号经常购买商品的分类
  function changeRecentTabItem(key){
    activeRecentProductKey.value = key
    if(key==''){
      //全部分类
      hotProductCollegePageParams.value.currentPage = 1
      hotProductCollegePageParams.value.pageSize = 12

    }
    if(hotProductCollegePageParams.value.currentPage>1){
      hotProductCollegePageParams.value.currentPage = 1
    }
    getProductList()
    // frequentCollegeList.value.map(item=>{
    //   if(item.productCategoryId===key){
    //     _frequentCollegeList.value = item.productSimpleDtoList
    //   }
    // })
  }
  
  // 高校分类
  const cateRecentList = ref([])
  //高校账户获取商品分类
  function getCategoryIsCollegeList() {
    let q = {
      source: 'USER_PC',
      // supplierIds: (selectCondition.list.filter(v => v.searchId != 0 && v.type == 'supplier').map(v => v.searchId)).join(',')
    }
    api.buyer_category_list(q).then(res => {
      if (res) {
        cateRecentList.value = [{
            productCategoryId: '',
            productCategoryName: '全部'
          }]
        res.map(item => {
          cateRecentList.value.push({
            productCategoryId: item.categoryId,
            productCategoryName: item.categoryName
          })
        })
        activeRecentProductKey.value = cateRecentList.value[0].productCategoryId
      }
    })
  }
  function getProductList() {
  let categoryIds = activeRecentProductKey.value
  let q = {
    source: 'USER_PC',
    categoryIds,
    ...hotProductCollegePageParams.value
    // supplierIds: searchParams.value.supplierId ? searchParams.value.supplierId : '',
  }
  api
    .buyer_product_list2(q)
    .then(res => {
      res.list.map(newValue => {
        newValue.priceRange = ''
        if (newValue.priceType === 'LADDER') {
          newValue.priceRange = getLowPrice(newValue?.productPriceDtos || [], newValue.discounts || 0) + '~' + getHightPrice(newValue?.productPriceDtos || [], newValue.discounts || 0)
        }
        if (newValue.priceType === 'FIXED') {
          newValue.priceRange = utils.toFixed2(newValue.actualPrice)
        }
      })
      if(res){
        if(q.currentPage==1){
          _frequentCollegeList.value = res.list
        }else{
          _frequentCollegeList.value = _frequentCollegeList.value.concat(res.list)
        }
        hotProductCollegePageParams.value.total = res.total
      }
    })
    .catch(err => {
      // proSpinning.value = false
    })
}
// 获取最高价格
function getHightPrice(arr, discounts) {
  let price = 0
  arr.map(item => {
    if (item.rangeMin === 0) {
      price = utils.toFixed2(item.price * (1 - discounts / 100))
    }
  })
  return price
}
// 获取最低价格
function getLowPrice(arr, discounts) {
  let price = 0
  arr.map(item => {
    if (item.rangeMax < 0) {
      price = utils.toFixed2(item.price * (1 - discounts / 100))
    }
  })
  return price
}

  // 高校账户经常购买
  function getFrequentCollegeList(){
    console.log('学校经常购买')
    api.buyer_product_list({source: 'USER'}).then(res=>{
      if(res){
        frequentCollegeList.value = res
        cateRecentList.value = []
        res.map(item=>{
          cateRecentList.value.push({
            productCategoryId: item.productCategoryId,
            productCategoryName: item.productCategoryName
          }) 
        })
        _frequentCollegeList.value = res[0]?.productSimpleDtoList
        activeRecentProductKey.value = res[0]?.productCategoryId
      }
    })
  }
  // 经常购买/热销商品 列表加载下一页
  function parentLoadMore(type){
    if(type=='hot'){
      hotProductPageParams.value.currentPage++
      getHotProductList()
    }
    // if(type=='frequent'){
    //   searchFrequentParams.value.currentPage++
    //   getFrequentCollegeList()
    // }
  }
    // 学校经常购买/热销商品 列表加载下一页
  function parentLoadMoreCollege(){
     hotProductCollegePageParams.value.currentPage++
     getProductList()
    
    // if(type=='frequent'){
    //   searchFrequentParams.value.currentPage++
    //   getFrequentCollegeList()
    // }
  }
  // 经常购买/热销商品 列表收起
  function packUpFun(type){
    if(type=='hot'){
      hotProductPageParams.value.currentPage = 1
      getHotProductList()
    }
    // if(type=='frequent'){
    //   searchFrequentParams.value.currentPage = 1
    //   getFrequentCollegeList()
    // }
  }

  function packUpCollegeFun(){

    hotProductCollegePageParams.value.currentPage = 1
    getProductList()
    
    // if(type=='frequent'){
    //   searchFrequentParams.value.currentPage = 1
    //   getFrequentCollegeList()
    // }
  }
  // 最近购买的商品
  const frequentList = ref([])//
  // 获取经常购买的数据
  function getFrequentList(){
    api.get_plat_recentPurchaseProduct().then(res=>{
      frequentList.value = sliceArray(res,4)
      // console.log('res',sliceArray([1,2],4))
    })
  }
  /*
  *array分割的原数组
  *size 分割成等长子数组的长度
  */
  function sliceArray(array,size){
    var result = [];
    for(var i=0;i<Math.ceil(array.length/size);i++){
           var start = i * size;
           var end = start + size;
           result.push(array.slice(start, end));
    }
    return result;  
}
  // 轮播经常购买箭头是否显示
  const isShowArrows = ref(false)
  // 搜索条件
  const searchParams = ref({
    type:'supplier',
    likeName:null
  })
  const searchParamsCollege = ref({
    type:'product',
    likeName:null
  })
  
  // 价格列表
  const priceList = ref([]);
  const timer = ref(null)
  const cateIsHover = ref(null)//存放hover id
  // 跳转至首页
  function toPage(url,name){
      router.push(url)
  }
  

  // 关键字搜索
  function toSearchPage(){
    if(userInfo.value.isCollege||userInfo.value.isWarehouse){
      //学校跳转新商城页面
      router.push({
      path: searchParamsCollege.value.type==='product'?'/main/buyMallNew':'/',
      query:{likeName: searchParamsCollege.value.likeName}
    })
    }else{
      router.push({
      path: searchParams.value.type==='product'?'/main/buyMall':'/main/store/list',
      query:{likeName: searchParams.value.likeName}
    })
    }
    
  }

  // 热销商品tab key
  const activeHotProductKey = ref('')
  // 切换热销商品的分类
  function changeTabItem(key){
    activeHotProductKey.value = key
    hotProductPageParams.value.currentPage=1
    getHotProductList()
    // console.log(key)
  }
  // 热销商品list
  const hotProductList = ref([])
  // 热销商品搜索条件
  const hotProductPageParams = ref({
    currentPage:1,
    pageSize:12,
    total:0
  })
  const hotProductCollegePageParams = ref({
    currentPage:1,
    pageSize:12,
    total:0
  })
  // 获取热销商品
  function getHotProductList(){
    let p = {
      categoryIds:[activeHotProductKey.value],
      districtCode:currentCity.value.code,
      ...hotProductPageParams.value
    }
    // if(!p.districtCode){
    //   delete p.districtCode
    // }
    if(!activeHotProductKey.value){
      delete p.categoryIds
    }
    if(userInfo.value && userInfo.value.businessLevel=='ADMIN' && userInfo.value.businessType=='COMPANY' && userInfo.value.auditState=='PASSED'){
      p.businessOrgId =  userInfo.value.businessOrgId
    }
    api.post_plat_index_getProduct(p).then(res=>{
      if(res){
        if(p.currentPage==1){
          hotProductList.value = res.list
        }else{
          hotProductList.value = hotProductList.value.concat(res.list)
        }
        hotProductPageParams.value.total = res.total
      }
    })
  }
  // 商品分类选中的对象
  const hoverCateObj = ref({
    name:null,
    list:[1,2,3,4,5,6,7,8,9,]
  })
  const cateList = ref([])
  // 获取商品分类
  function getCategoryList(){
    api.get_plat_index_getProductCategory().then(res=>{
      if(res){
        cateList.value = res
      }
    })
  }
  // 获取轮播图
  function getBanner(){
    
    api.get_config_banner().then(res=>{
      if(res){
        bannerList.value = res
      }
    })
  }
  // 舆情信息
  function getNewsList(){
    api.get_OfficialWebsite_news_list({currentPage:1,pageSize:12,showType:'showPlat'}).then(res=>{
      if(res){
        newsObj.value = res.list
      }
    })
  }
  // 价格走势
  function getPriceTrend(){
    api.get_product_priceTrend_list({
      currentPage:1,pageSize:10,
      district:currentCity.value.code,
      businessType:userInfo.value.isCollege?'BUYER':'COMPANY'
    }).then(res=>{
      if(res){
        priceList.value = res.list
      }
    })
  }

  const noticeList = ref([])
  // 平台消息
  function getNotice(){
    api.get_buyer_index_advice_list({currentPage:1,pageSize:10,type:'suibian'}).then(res=>{
      if(res){
        noticeList.value = res
      }
    })
  }

  // 切换商品分类
  function changeCateProduct(parentId,childId){
    console.log(11111)
    if(userInfo.value.isCollege||userInfo.value.isWarehouse){
      changeRecentTabItem(parentId)
    }else{
      changeTabItem(parentId)
      // activeHotProductKey.value = parentId
      // hotProductPageParams.value.currentPage=1
      // getHotProductList()
    }
  }
  function initData(){
    getHotProductList()
    getSupplierList()
    // console.log(isCollegeUser.value)
    getBanner()
    getNewsList()
    getPriceTrend()
    
  }
  onMounted(() => {
    getCategoryList()

    getHotProductList()
    getSupplierList()
    getBanner()
    getNewsList()
    // console.log(userInfo.value.userId)
    if(!userInfo.value.userId){
      getPriceTrend()
    }
  })

  watch(()=> store.state.city.currentCity, val=>{
      initData()
    },
    // { immediate: true }
  )
  watch(()=> store.state.user.userInfo.userId, (newUser,oldUser)=>{
    
    if(!oldUser && newUser){
      // console.log('oldUser',oldUser,'newUser',newUser)
      let _userInfo = store.state.user.userInfo
      if(isCollegeUser.value||_userInfo.isWarehouse){
        // getFrequentCollegeList()
        getNotice()
        getSupplierList()
        getCategoryIsCollegeList()//获取高校商品分类
        getProductList()//获取高校商品
      }
      if(_userInfo.businessType==='COMPANY' && _userInfo.orgState==='FORBIDDEN'){
        getFrequentList()
      }
      getHotProductList()
      getSupplierList()
      getPriceTrend()
    }
  },
  { immediate: true }
)
  // 跳转管理后台
function openManagerPage() {
  router.push({
    path: '/main/personalCenter/userInfo',
  })
}
  // 鼠标悬浮
  function enterCate(item){
    hoverCateObj.value = {
      id: item.id,
      name:item.name,
      list: item.children
    }
    cateIsHover.value = item
  }
  // 鼠标离开一级分类盒子倒计时
  function cateLeaveTimer(){
    timer.value = setTimeout(()=>{
      cateIsHover.value = false
      clearTimeout(timer.value)
    },2000)
  }
  // 清除定时器
  function clearTimer(){
    clearTimeout(timer.value)
  }
</script>
<style scoped lang="scss">
  @import './index.scss';
</style>
